import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import Controller, { ControllerProps } from './Controller';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './contexts/ToastContext';
import './styles/index.css';

// Re-export types for consuming applications
export * from './types';
export type { ControllerProps } from './Controller';

/**
 * Wrapper component for the Workflow Editor that provides necessary contexts.
 * This is the main entry point for the CDN bundle.
 */
export const WorkflowEditorWrapper: React.FC<ControllerProps> = (props) => {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <ReactFlowProvider>
          <div style={{ width: '100%', height: '100%' }}>
            <Controller {...props} />
          </div>
        </ReactFlowProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};

export default WorkflowEditorWrapper;
